import React, { useEffect, useState } from "react";
import Commonselectfield from "../../../Components/CommonForms/CommonSelectField";
import classes from "./Subscription.module.css";
import { Col } from "antd";
import ShowMoreText from "../../../Components/CommonText/ShowMoreText";
import CommonButton from "../../../Components/Buttons/CommonButton";
import { SendSubscription } from "../../../Services/ApiServices";
import {
  CatchMessage,
  JSONtoformdata,
  tokenisValid,
} from "../../../Shared/Methods";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../../Store/Redux/Reducers/Dashboardreducers";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../../Store/Redux/Reducers/Authreducers";
import { useFormik } from "formik";
import * as Yup from "yup";

const validation = Yup.object().shape({
  meter_id: Yup.string().required("Subscription is required"),
});

function SubscriptionCard({
  ele,
  // showmoreindex,
  Description,
  ind,
  // ShowMore,
  // openselect,
  // handleOpenSelect,
  // setFieldValue,
  DropDowns,
}: // values,
// errors,
// touched,
// setsubseriptvalue,
// handleSubmit,
{
  ele: any;
  // showmoreindex: any;
  Description: any;
  ind: number;
  // ShowMore: any;
  // openselect: any;
  // handleOpenSelect: any;
  // setFieldValue: any;
  DropDowns: any;
  // values: any;
  // errors: any;
  // touched: any;
  // setsubseriptvalue: any;
  // handleSubmit: any;
}) {
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [subscriptvalues, setsubseriptvalue] = useState<any>({});
  const [openselect, setopenselect] = useState<any>({
    isView: false,
  });
  const [showtext, setShowtext] = useState(false);

  const {
    values,
    errors,
    touched,
    setFieldValue,
    setValues,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues: {
      meter_id: null,
    },
    validationSchema: validation,
    onSubmit: (values) => {
      handleSendSubscription();
    },
  });

  useEffect(() => {
    resetForm();
  }, [openselect]);

  const handleSendSubscription = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
      subscription_id: subscriptvalues?.subscription_id || "",
      subscription_name: subscriptvalues?.subscription_name || "",
      subscription_description: subscriptvalues?.subscription_description || "",
      validity: subscriptvalues?.validity || "",
      cost: subscriptvalues?.cost || "",
    };

    SendSubscription(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          toast.success(res?.data?.msg);
          setopenselect({ isView: false });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const handleOpenSelect = (ind: number) => {
    setopenselect({ isView: !openselect?.isView });
  };

  return (
    <>
      <Col xxl={4} xl={6} lg={8} md={12} sm={12} xs={24}>
        <div className={classes.subscription_container}>
          <div className={classes.sub_container_bottom}>
            <p className={classes.pro_text}>{ele?.subscription_name}</p>
          </div>
          <div style={{ padding: "15px" }}>
            <p className={classes.pro_count_center}>
              <span className={classes.pro_count}>
                {ele?.subscription_price}
              </span>
              /{ele?.subscription_month}
            </p>
            <div>
              <p
                className={classes.description_container}
                style={showtext ? { height: "auto" } : { height: "114px" }}
              >
                {Description?.map((ele: any, index: number) => {
                  return <p>{ele}</p>;
                })}
              </p>
              {Description?.length > 4 ? (
                <ShowMoreText
                  // width: "63px"
                  style={{ textAlign: "start" }}
                  handleSuccess={() => setShowtext(!showtext)}
                  showtext={showtext}
                />
              ) : null}
            </div>

            <div className={classes.select_button_container}>
              <CommonButton
                name={openselect?.isView ? "UnSelect" : "Select"}
                onClick={() => {
                  handleOpenSelect(ind);
                }}
                type="button"
                classname={openselect?.isView ? "unselect_btn" : "submit_btn"}
              />
            </div>

            {openselect?.isView ? (
              <>
                <div>
                  <Commonselectfield
                    value={values.meter_id}
                    onChange={(value: any) => {
                      setFieldValue("meter_id", value);
                    }}
                    options={DropDowns?.Meter?.map((ele: any) => {
                      return {
                        label: `${ele.meter_name} - ${ele?.meter_code}`,
                        value: ele?.id,
                        // disabled: ele?.subscription_status !== 1,
                        // title:
                        //   ele?.subscription_status !== 1
                        //     ? "Not Subscribed"
                        //     : ele?.meter_name,
                      };
                    })}
                    size="large"
                    labelname="Subscription"
                    style={{ width: "100%" }}
                    error={errors}
                    required={true}
                    touched={touched}
                    name="meter_id"
                  />
                </div>

                <div
                  className={classes.select_button_container}
                  style={{ justifyContent: "center" }}
                >
                  <CommonButton
                    name="Submit"
                    onClick={() => {
                      setsubseriptvalue(ele);
                      handleSubmit();
                    }}
                    type="submit"
                    classname="submit_btn"
                  />
                </div>
              </>
            ) : null}
          </div>
        </div>
      </Col>
    </>
  );
}

export default SubscriptionCard;
